export const LOADING_STATUS = {
  FETCHING: "fetching",
  REFRESHING: "refreshing",
  COMPLETED: "completed",
  FAILED: "failed",
};
